module.exports = __webpack_public_path__ + "public/img/phone.6d1d596b.png";